// extracted by mini-css-extract-plugin
export default {"background":"Ln3u5","language-de":"SZCbx","language-en":"Qm1pA","language-es":"WL6XV","language-fr":"iUBOo","language-it":"uIuci","language-nl":"cInBw"};